import globalClasses from "../../../commoncomponents/css/Global.module.css";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import CommonLayout from "../../../commoncomponents/layout/CommonLayout";
import { getRequest } from "../../../../api/AxiosAPICall";
import { Typography, Grid, Box, Link } from "@mui/material";
import { useDispatch } from "react-redux";

const GenerateQrCodes = () => {
  const dispatch = useDispatch();
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const generateQrCodesDetails = async () => {
    const response = await getRequest("generateQRcode", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      console.log(response.toString());
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else {
      dispatch(
        setSnackbar(
          true,
          4000,
          "success",
          "QR codes generated successfully.",
          "top",
          "center"
        )
      );
    }
  };
  return (
    <CommonLayout
      footer={true}
      hidePermium={false}
      showHeaderNavigation={true}
      isLogedIn={true}
    >
      <Box
        className={globalClasses.card}
        sx={{
          backgroundColor: "#e9e6e6",
          width: "100%",
          alignSelf: "center",
          alignItems: "center",
          padding: "5px,5px",
        }}
      >
        <Grid
          container
          sx={{ textAlign: "Left", paddingTop: "5px", paddingBottom: "5px" }}
        >
          <Grid item xs={12} sx={{ fontSize: "20px" }}>
            <Typography
              sx={{
                paddingLeft: "5px",
                paddingRight: "5px",
                fontSize: "20px",
                display: "inline-block",
                fontWeight: "bold !important",
                color: "white",
                textAlign: "left",
                textTransform: "none",
                backgroundColor: "#1f376e",
              }}
            >
              Generate QR Code for all Establishment Health Professionals
            </Typography>
          </Grid>
        </Grid>
        <Grid container sx={{ textAlign: "Left" }}>
          <Grid item xs={12}>
            <Link sx={{ cursor: "pointer" }} onClick={generateQrCodesDetails}>
              Generate QR Code
            </Link>
          </Grid>
        </Grid>
      </Box>
    </CommonLayout>
  );
};
export default GenerateQrCodes;
